const externalRoutes: any = {
  search_path: '/writer_dashboard/search', // not actually external but routerLinkActive not working
  customers_path: '/customers',
  assigned_keywords_path: '/keywords?tab=assigned',
  writer_pool_keywords_path: '/keywords?tab=pool',
  deadline_keywords_path: '/keywords?tab=deadlines',
  most_wanted_keywords_path: '/keywords?tab=most_wanted',
  most_urgent_customers_path: '/customers/most_urgent',
  invoices_path: '/invoices',
  forum_path: '/forum',
  edit_user_registration_path: '/d/users/edit',
  edit_email_preferences_user_path: '/users/:id/edit_email_preferences',
  edit_writer_path: 'writers/:id/edit',
  edit_writer_profile_path: '/writer_profiles/:id/edit',
  edit_writer_w9_record_path: '/writers/:id/w9_record/edit',
  new_writer_w9_record_path: '/writers/:id/w9_record/new',
  new_writer_goal_path: '/writer_goal/new',
  destroy_user_session_path: '/d/users/sign_out',
  help_path: '/help',
  contact_link: 'mailto:writers@verblio.com',
}

export function externalRoute(path: string, id: string | number = null): any {
  let route = externalRoutes[path]
  if (id && route.includes(':id')) { route = route.replace(':id', id) }
  return route
}
